import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ee7dbd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ManualGeneration" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = { class: "bg-white border px-4 py-2" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_6 = { class: "bg-white border px-4 py-2 mt-6" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col items-center justify-center select-none"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка накладных...", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-400" }, "При получении накладных произошла ошибка", -1))
const _hoisted_10 = {
  key: 2,
  class: "text-sm text-gray-400"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "grid grid-cols-4 gap-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_14 = { class: "bg-white border px-6 py-4 mt-3" }
const _hoisted_15 = { class: "grid grid-cols-4 gap-3" }
const _hoisted_16 = {
  key: 0,
  class: "select-none flex items-center justify-center flex-col"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Список пуст", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "grid grid-cols-4 gap-3 mt-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_23 = { class: "flex items-center justify-end mt-2" }
const _hoisted_24 = { class: "mt-6 flex items-center justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Ручная генерация транскрипта" }),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _ctx.onRouteBack
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("form", {
      class: "mt-6",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_the_select, {
            placeholder: "Контрагент",
            loading: _ctx.data_state.companies.is_loading,
            failed: _ctx.data_state.companies.is_failed,
            "error-text": "При получении списка компаний произошла ошибка",
            options: _ctx.data_state.companies.list,
            disabled: _ctx.state.is_generating,
            "is-invalid": _ctx.state_form$.payerCompanyId.$error,
            "validation-errors": _ctx.state_form$.payerCompanyId.$errors,
            value: _ctx.state.payerCompanyId,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.payerCompanyId) = $event)),
            "search-without-refresh": "",
            class: "mt-2",
            onRefresh: _ctx.loadCompanies,
            onChange: _ctx.loadCalculations
          }, null, 8, ["loading", "failed", "options", "disabled", "is-invalid", "validation-errors", "value", "onRefresh", "onChange"]),
          _createVNode(_component_the_input, {
            value: _ctx.state.turnoverDate,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.turnoverDate) = $event)),
            disabled: _ctx.state.is_generating,
            "is-invalid": _ctx.state_form$.turnoverDate.$error,
            "validation-errors": _ctx.state_form$.turnoverDate.$errors,
            type: "date",
            placeholder: "Дата АВР"
          }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
        ])
      ]),
      _createVNode(_component_page_title, {
        title: `Накладные (${_ctx.state.calculations.length})`,
        class: "mt-6"
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_6, [
        (
                        _ctx.state.is_calculations_loading ||
                        _ctx.state.is_calculations_failed ||
                        _ctx.state.calculations.length === 0
                    )
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.state.is_calculations_loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_loader, { class: "primary" }),
                    _hoisted_8
                  ], 64))
                : (_ctx.state.is_calculations_failed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_9,
                      _createVNode(_component_the_button, {
                        class: "primary small mt-2",
                        onClick: _ctx.loadCalculations
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Обновить ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_ctx.state.calculations.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Нет накладных"))
                    : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.calculations, (calculation) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: calculation.id,
                    class: "border border-gray-300 rounded px-3 py-1 flex items-center justify-between"
                  }, [
                    _createElementVNode("div", null, _toDisplayString(calculation.invoiceNumber), 1),
                    _createVNode(_component_the_button, {
                      class: "red small text",
                      disabled: _ctx.state.is_generating,
                      onClick: ($event: any) => (_ctx.onRemoveCalculation(calculation))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])
                  ]))
                }), 128))
              ])
            ]))
      ]),
      _createVNode(_component_page_title, {
        title: "Добавление вычислений",
        class: "mt-6"
      }),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_the_input, {
            placeholder: "Поиск",
            value: _ctx.state.query,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.query) = $event)),
            disabled: _ctx.state.is_generating
          }, null, 8, ["value", "disabled"])
        ]),
        (_ctx.renderedCalculations.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderedCalculations, (calculation) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `search-${calculation.id}`,
                    class: "border border-gray-300 rounded px-3 py-1 flex items-center justify-between"
                  }, [
                    _createElementVNode("div", null, _toDisplayString(calculation.invoiceNumber), 1),
                    (_ctx.isCalculationAlreadyAdded(calculation.id))
                      ? (_openBlock(), _createBlock(_component_the_button, {
                          key: 0,
                          class: "red small text",
                          disabled: _ctx.state.is_generating,
                          onClick: ($event: any) => (_ctx.onRemoveCalculation(calculation))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_21
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"]))
                      : (_openBlock(), _createBlock(_component_the_button, {
                          key: 1,
                          class: "green small text",
                          disabled: _ctx.state.is_generating,
                          onClick: ($event: any) => (_ctx.onAddCalculation(calculation))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"]))
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_the_button, {
                  class: "small primary",
                  disabled: _ctx.state.is_generating,
                  onClick: _ctx.addAll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Выбрать все ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_the_button, {
          class: "small primary",
          type: "submit",
          loading: _ctx.state.is_generating,
          disabled: _ctx.state.is_generating
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Сгенерировать ")
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ], 32)
  ]))
}